import React from "react";

import { CallToActionComponent } from "./callToAction.component";
import { CallToActionContextProvider } from "./callToAction.context";
import { ButtonCallToAction } from "./components/ButtonCallToAction/buttonCallToAction.container";
import { CallToActionContent } from "./components/CallToActionContent/callToActionContent.container";
import { LinkCallToAction } from "./components/LinkCallToAction/linkCallToAction.container";
import { Action } from "./types/action.types";
import { Content } from "./types/content.types";
import { CallToActionType } from "./types/enums/callToActionType.enum";
import { Link } from "./types/link.types";
import { PrefetchedData } from "./types/prefetchedData.types";
import { Style } from "./types/style.types";
import { Tracking } from "./types/tracking.types";

export type CallToActionButtonProps = {
    callToActionType: CallToActionType.BUTTON;
    action: Action;
};

export type CallToActionLinkProps = {
    callToActionType: CallToActionType.LINK;
    link: Link;
};

export type CallToActionProps = {
    content: Content;
    tracking: Tracking;
    marginClass?: string;
    style: Style;
    prefetchedData?: PrefetchedData;
} & (CallToActionButtonProps | CallToActionLinkProps);

const CallToAction = (props: CallToActionProps) => {
    const content = <CallToActionContent {...props.content} />;

    return (
        <CallToActionContextProvider
            callToActionType={props.callToActionType}
            tracking={props.tracking}
            style={props.style}
        >
            <CallToActionComponent marginClass={props.marginClass}>
                {props.callToActionType === CallToActionType.BUTTON ? (
                    <ButtonCallToAction
                        action={props.action}
                        prefetchedData={props.prefetchedData}
                    >
                        {content}
                    </ButtonCallToAction>
                ) : (
                    <LinkCallToAction link={props.link}>
                        {content}
                    </LinkCallToAction>
                )}
            </CallToActionComponent>
        </CallToActionContextProvider>
    );
};

export { CallToAction };
